import { SuretyAccountId, SuretyIndemnityAgreementId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondPreviewsQueryKey } from "../../bond/bond.keys";
import { bondRequestPreviewsQueryKey } from "../../bond-request/bond-request.keys";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import {
	accountIndemnityAgreementsQueryKey,
	accountLatestIndemnityAgreementQueryKey,
	accountQueryKey,
} from "../account.keys";

export const useAdminApproveAgentUploadIndemnityAgreement = (
	accountId: SuretyAccountId,
	indemnityAgreementId: SuretyIndemnityAgreementId,
) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		mutationKey: ["accounts", accountId, "indemnity-agreements", indemnityAgreementId, "approve"],
		mutationFn: async () => {
			await post(
				`/v2/admin/surety/accounts/${accountId}/indemnity-agreements/${indemnityAgreementId}/approve`,
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() });
			queryClient.invalidateQueries({
				queryKey: accountIndemnityAgreementsQueryKey(accountId, indemnityAgreementId),
			});
			queryClient.invalidateQueries({
				queryKey: accountLatestIndemnityAgreementQueryKey(accountId),
			});
			queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: bondPreviewsQueryKey(accountId) });
		},
	});

	return {
		approveAgentUploadIndemnityAgreement: mutation.mutate,
		approveAgentUploadIndemnityAgreementIsLoading: mutation.isPending,
	};
};
